import { render, staticRenderFns } from "./BatchesList.vue?vue&type=template&id=6c04fe87&scoped=true"
import script from "./BatchesList.vue?vue&type=script&lang=js"
export * from "./BatchesList.vue?vue&type=script&lang=js"
import style0 from "./BatchesList.vue?vue&type=style&index=0&id=6c04fe87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c04fe87",
  null
  
)

export default component.exports